<div class="modal-header">
  <h5 class="modal-title"><i class="fas fa-bolt mr-2"></i>{{title}}</h5>
  <button type="button" class="close basic-close" (click)="onClose()"><span>&times;</span></button>
</div>

<div class="modal-body">
  <div class="wizard-stepper">
    <div class="step" [ngClass]="{'active': currentStep === 1, 'done': currentStep > 1}">
      <span class="step-num">1</span>Ciblage
    </div>
    <div class="step-separator"></div>
    <div class="step" [ngClass]="{'active': currentStep === 2, 'done': currentStep > 2}">
      <span class="step-num">2</span>Saisie / Import
    </div>
    <div class="step-separator"></div>
    <div class="step" [ngClass]="{'active': currentStep === 3}">
      <span class="step-num">3</span>Preview & Validation
    </div>
  </div>

  <!-- ==================== ÉTAPE 1 : CIBLAGE ==================== -->
  <div *ngIf="currentStep === 1">
    <div class="row mb-3">
      <div class="col-md-6">
        <label>Période de consommation (mois) <span class="text-danger">*</span></label>
        <input type="date" [(ngModel)]="periode" class="form-control">
      </div>
      <div class="col-md-6">
        <label>Date de prélèvement <span class="text-danger">*</span></label>
        <input type="date" [(ngModel)]="datePrelevement" class="form-control">
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-6">
        <label>Immeubles concernés <span class="text-danger">*</span></label>
      </div>
      <div class="col-md-6 text-right">
        <span class="badge badge-primary">{{selectedHouses.length}} sélectionné(s)</span>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-8">
        <input type="text" class="form-control" placeholder="Rechercher un immeuble..." [(ngModel)]="houseSearch">
      </div>
      <div class="col-md-4 text-right">
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleAll()">
          <i class="feather" [ngClass]="allFilteredSelected ? 'icon-square' : 'icon-check-square'"></i>
          {{allFilteredSelected ? 'Tout désélectionner' : 'Tout sélectionner'}}
        </button>
      </div>
    </div>

    <div *ngIf="loadingHouses" class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
    <div class="house-grid" *ngIf="!loadingHouses">
      <div class="house-card" *ngFor="let h of filteredHouses"
           [ngClass]="{'selected': h.selected}" (click)="toggleHouse(h)">
        <input type="checkbox" class="check-box" [checked]="h.selected" (click)="$event.stopPropagation()"
               (change)="toggleHouse(h)">
        <div class="house-info">
          <div class="house-nom">{{h.nom}}</div>
          <div class="house-meta" *ngIf="h.rentalsCount">{{h.rentalsCount}} locative(s)</div>
        </div>
      </div>
      <div *ngIf="filteredHouses.length === 0" class="text-muted text-center p-3" style="grid-column:1/-1">
        Aucun immeuble trouvé
      </div>
    </div>
  </div>

  <!-- ==================== ÉTAPE 2 : SAISIE / UPLOAD ==================== -->
  <div *ngIf="currentStep === 2">
    <div class="alert alert-info mb-2">
      <i class="fas fa-info-circle mr-1"></i>
      <strong>{{selectedHouses.length}}</strong> immeuble(s) sélectionné(s) —
      Période : <strong>{{periode}}</strong> —
      Date prélèvement : <strong>{{datePrelevement}}</strong>
    </div>

    <div class="nav-tabs-modern">
      <div class="tab-item" [ngClass]="{'active': activeTab === 'manual'}" (click)="activeTab = 'manual'">
        <i class="fas fa-keyboard mr-1"></i>Saisie manuelle
      </div>
      <div class="tab-item" [ngClass]="{'active': activeTab === 'upload'}" (click)="activeTab = 'upload'">
        <i class="fas fa-file-excel mr-1"></i>Import Excel
      </div>
    </div>

    <!-- Onglet A : saisie manuelle -->
    <div *ngIf="activeTab === 'manual'">
      <div *ngIf="loadingContracts" class="text-center py-4">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="mt-2">Chargement des contrats...</p>
      </div>
      <div *ngIf="!loadingContracts && contractRows.length === 0" class="alert alert-warning">
        Aucun contrat actif trouvé pour les immeubles sélectionnés.
      </div>
      <div *ngIf="!loadingContracts && contractRows.length > 0" class="table-responsive">
        <table class="manual-table">
          <thead>
            <tr>
              <th>Inclure</th>
              <th>Immeuble</th>
              <th>Porte</th>
              <th>Contrat</th>
              <th>Locataire</th>
              <th>Index préc.</th>
              <th>Index fin <span class="text-warning">*</span></th>
              <th>Conso</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of contractRows" [style.opacity]="row.excluded ? 0.4 : 1">
              <td>
                <input type="checkbox" [checked]="!row.excluded" (change)="row.excluded = !row.excluded">
              </td>
              <td>{{row.houseNom}}</td>
              <td>{{row.porte}}</td>
              <td><code>{{row.code}}</code></td>
              <td>{{row.tenantNom}}</td>
              <td class="prev-index">{{row.lastIndex | number}}</td>
              <td>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="row.fin"
                       (input)="onFinChange(row)" [disabled]="row.excluded" placeholder="0">
              </td>
              <td><strong>{{row.conso | number}}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Onglet B : upload Excel -->
    <div *ngIf="activeTab === 'upload'">
      <div class="row">
        <div class="col-md-6">
          <div class="card h-100">
            <div class="card-body text-center">
              <i class="fas fa-download fa-3x text-primary mb-3"></i>
              <h6>Étape A — Télécharger le template pré-rempli</h6>
              <p class="text-muted small">
                Le fichier contient tous les contrats des immeubles sélectionnés
                avec index précédent déjà rempli. Vous complétez uniquement l'index
                de fin et la date.
              </p>
              <button type="button" class="btn btn-primary" (click)="downloadTemplate()">
                <i class="fas fa-file-download mr-1"></i>Télécharger le template
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card h-100">
            <div class="card-body">
              <div class="text-center mb-3">
                <i class="fas fa-upload fa-3x text-success mb-2"></i>
                <h6>Étape B — Uploader le fichier rempli</h6>
              </div>
              <div class="upload-zone" [ngClass]="{'has-file': selectedFile}">
                <div *ngIf="!selectedFile">
                  <i class="fas fa-file-excel fa-2x mb-2"></i>
                  <p class="mb-2">Déposez votre fichier Excel ici</p>
                  <label class="btn btn-outline-primary btn-sm mb-0">
                    <input type="file" accept=".xlsx,.xls" (change)="onFileSelected($event)" hidden>
                    Parcourir
                  </label>
                </div>
                <div *ngIf="selectedFile">
                  <i class="fas fa-check-circle fa-2x text-success mb-2"></i>
                  <p class="mb-1"><strong>{{selectedFile.name}}</strong></p>
                  <small class="text-muted">{{(selectedFile.size / 1024) | number: '1.0-0'}} Ko</small>
                  <div class="mt-2">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearFile()">
                      <i class="fas fa-times"></i> Retirer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== ÉTAPE 3 : PREVIEW ==================== -->
  <div *ngIf="currentStep === 3">
    <div class="stats-bar">
      <div class="stat-card success"><span class="stat-value">{{totalNouveau}}</span>Nouveau</div>
      <div class="stat-card warning"><span class="stat-value">{{totalMiseAJour}}</span>Mise à jour</div>
      <div class="stat-card danger"><span class="stat-value">{{totalErreur}}</span>Erreur</div>
      <div class="stat-card info"><span class="stat-value">{{montantTotal | number}}</span>{{global.device}}</div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead class="thead-light">
          <tr>
            <th>Ligne</th>
            <th>Locataire</th>
            <th>Porte</th>
            <th>Loyer matché</th>
            <th>Début</th>
            <th>Fin</th>
            <th>Conso</th>
            <th>Montant</th>
            <th>Statut</th>
            <th style="min-width:260px;">Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of previewData; let i = index">
            <td>{{line.ligne}}</td>
            <td>{{line.locataire}}</td>
            <td>{{line.porte}}</td>
            <td>
              <small *ngIf="line.moisRent" class="d-block font-weight-bold text-info">{{line.moisRent}}</small>
              <small *ngIf="line.dateRent" class="d-block text-muted">{{line.dateRent}}</small>
              <small *ngIf="!line.moisRent" class="text-muted">—</small>
            </td>
            <td>
              <span *ngIf="!line.editing">{{line.debut | number}}</span>
              <input *ngIf="line.editing" type="number" class="form-control form-control-sm" [(ngModel)]="line.debut">
            </td>
            <td>
              <span *ngIf="!line.editing">{{line.fin | number}}</span>
              <input *ngIf="line.editing" type="number" class="form-control form-control-sm" [(ngModel)]="line.fin">
            </td>
            <td><strong>{{line.conso | number}}</strong></td>
            <td>{{line.montant | number}} {{global.device}}</td>
            <td><span class="badge" [ngClass]="getStatusBadgeClass(line.statut)">{{line.statut}}</span></td>
            <td style="white-space:normal; min-width:260px;">
              <span [ngClass]="{'text-danger': line.statut === 'ERREUR'}">{{line.message}}</span>
            </td>
            <td>
              <button *ngIf="!line.editing && line.editable" type="button" class="btn btn-xs btn-info" (click)="editLine(line)">
                <i class="feather icon-edit-2"></i>
              </button>
              <button *ngIf="line.editing" type="button" class="btn btn-xs btn-success" (click)="saveLine(line)">
                <i class="fas fa-check"></i>
              </button>
              <button *ngIf="line.editing" type="button" class="btn btn-xs btn-secondary" (click)="cancelEdit(line)">
                <i class="fas fa-times"></i>
              </button>
              <button type="button" class="btn btn-xs btn-danger" (click)="removeLine(i)">
                <i class="feather icon-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer wizard-actions-bar">
  <div>
    <button type="button" class="btn btn-secondary" (click)="onClose()">
      <i class="feather icon-x-circle"></i> Fermer
    </button>
  </div>
  <div>
    <button *ngIf="currentStep > 1" type="button" class="btn btn-outline-secondary mr-2" (click)="back()">
      <i class="feather icon-arrow-left"></i> Retour
    </button>
    <button *ngIf="currentStep === 1" type="button" class="btn btn-primary" [disabled]="!step1Valid" (click)="goToStep2()">
      Suivant : Saisie <i class="feather icon-arrow-right"></i>
    </button>
    <button *ngIf="currentStep === 2" type="button" class="btn btn-primary"
            [disabled]="previewLoading || uploadLoading" (click)="goToStep3()">
      <span *ngIf="previewLoading || uploadLoading"><i class="fa fa-spinner fa-spin"></i> Chargement...</span>
      <span *ngIf="!previewLoading && !uploadLoading">Suivant : Preview <i class="feather icon-arrow-right"></i></span>
    </button>
    <button *ngIf="currentStep === 3" type="button" class="btn btn-success" [disabled]="submitting" (click)="onValidate()">
      <span *ngIf="submitting"><i class="fa fa-spinner fa-spin"></i> Enregistrement...</span>
      <span *ngIf="!submitting"><i class="feather icon-save"></i> Enregistrer l'import</span>
    </button>
  </div>
</div>
